<template>
	<div>

		<div class="gywmMiddleBox" style="margin-top: 150px;">
			<div style="width: 1140px;min-width: 1140px;margin: auto;margin-top: 50px;">
				<div style="color: #150e52;font-size: 30px;font-weight: 600;text-align: center;">
					关于我们
				</div>
				<div class="gywm"  style="font-size: 16px;margin-top: 25px;line-height: 30px;color: #150e52;font-family: PingFangSC-Regular, sans-serif;"
             v-if="this.article"
				v-html="this.article.rows[0].content"
				>

				</div>
			</div>

		</div>

	</div>
</template>

<script>
	import mainTop from '../components/mainTop.vue'
	import mainBottom from '../components/mainBottom.vue'
	import axios from 'axios';
	export default {
	  components: {
		  mainTop,
		  mainBottom,

	   },
	   data(){
		   return{
			article:'',
			   };
			},
		created(){
			this.getArticle();
		},
		methods:{
			getArticle(){
				axios.get('/system/aboutUs/list?pageNum=1&pageSize=1').then((res)=>{
                    this.article=res.data
                })
			}
		},
		}
</script>

<style>
	.gywmMiddleBox{
		width: 100%;
		min-width: 1700px;
		background-color: #f7f7f7;
	}
	.gywm p img{
		width: 100%;
		height: 100%;
	}
</style>
